import { PartialId } from '@attain-apps/string-builder'

import * as core from '../../../../../../../../core'
import * as projectPis from '../../project-pis'

export const RESOURCE = {
  payload: {
    description:
      'The association(s) between principal investigator (PI) and a project. A PI may oversee multiple projects or share a project with other PIs.',
    dimension: projectPis.RESOURCE.payload,
    level: 0,
    name: 'Project PI',
    partialId: PartialId.Standard.create('entry'),
  },
  type: core.quiver.Resource.Type.DmsEntity,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsEntity>

export const MODEL_ID = core.dms.models.Entity.Id.from({
  context: core.dms.models.Entity.Id.Context.from(RESOURCE.payload.dimension),
  partialId: RESOURCE.payload.partialId,
})
